// Mirrors src/assets/css/tokens.css brand colors as RGB arrays for jsPDF
export const INK_900 = [27, 23, 48];
export const MUTED = [93, 107, 122];
export const MUTED_SOFT = [139, 151, 164];
export const LINE = [227, 232, 238];
export const SURFACE_2 = [248, 250, 252];
export const ACCENT_600 = [109, 84, 199];
export const ACCENT_050 = [240, 236, 250];
export const WHITE = [255, 255, 255];

// ARGB hex equivalents for ExcelJS cell fills/fonts/borders
export const HEX = {
  INK_900: "FF1B1730",
  MUTED: "FF5D6B7A",
  MUTED_SOFT: "FF8B97A4",
  LINE: "FFE3E8EE",
  SURFACE_2: "FFF8FAFC",
  ACCENT_600: "FF6D54C7",
  ACCENT_050: "FFF0ECFA",
  WHITE: "FFFFFFFF"
};
